import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    overflowX: 'auto',
    selectors: {
      '& .ms-DetailsHeader': {
        backgroundColor: theme.palette.neutralWhite,
        paddingTop: 0,
        borderBottom: `1px solid ${theme.palette.themePrimary}`,
      },
      '& .ms-DetailsHeader-cell[data-item-key="isRoyaltyBearing"]': {
        whiteSpace: 'normal',
        textOverflow: 'clip',
        lineHeight: 'normal',
      },
      '& .ms-DetailsHeader-cellTitle[data-item-key="isRoyaltyBearing"]': {
        height: '100%',
        alignItems: 'center',
      },
      '& .ms-DetailsHeader .ms-DetailsHeader-cellTitle': {
        color: theme.palette.neutralDark,
        height: '100%',
        alignItems: 'center',
        fontSize: pxToRem(14),
        fontWeight: 600,
        paddingLeft: '0',
        paddingRight: '0',
      },
      '& .ms-List-cell': {
        backgroundColor: theme.palette.neutralWhite,
        minHeight: 'auto',
      },
      '& .ms-List-cell:last-child .ms-DetailsRow': {
        // leave out for now cause so often the table calls for this bottom border
        // borderBottom: 'none',
      },
      [layout.breakpoints.min.md]: {
        overflowX: 'auto',
      },
    },
  },
  transparentBackground: {
    backgroundColor: 'transparent',
  },
  compactRow: {
    backgroundColor: theme.palette.neutralWhite,
    minHeight: 'auto',
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    selectors: {
      '& .ms-DetailsRow-cell': {
        position: 'relative',
        minHeight: 'auto',
        maxHeight: '1.6rem',
        padding: '.3rem .3rem .3rem 0',
        overflow: 'hidden',
        color: theme.palette.neutralSecondary,
        display: 'flex',
        alignItems: 'center',
      },
      '& .ms-DetailsRow-cell .overflow-tooltip': {
        maxWidth: '100%',
        display: 'inline-block',
      },
      '& .ms-DetailsRow-cell .overflow-tooltip .ms-TooltipHost': {
        display: 'block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
      },
      '& .ms-DetailsRow-cell[data-automation-key="allocationPercentage"]': {
        padding: '.25rem 0',
      },
      '& .ms-DetailsRow-cell[data-automation-key="isRoyaltyBearing"]': {
        padding: '.5rem .9rem',
      },
      '& .ms-DetailsRow-cell[data-automation-key="name"], & .ms-DetailsRow-cell[data-automation-key="title"]':
        {
          color: theme.palette.neutralDark,
          fontSize: pxToRem(14),
        },
    },
  },
  linkedRow: {
    cursor: 'pointer',
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette.neutralLighterAlt,
      },
    },
  },
  greyRow: {
    selectors: {
      '& .ms-DetailsRow-cell': {
        backgroundColor: theme.palette.neutralLighterAlt,
      },
    },
  },
  noBorderBottom: {
    selectors: {
      '.ms-List-cell:last-child .ms-DetailsRow': {
        borderBottom: 'none',
      },
      '& .ms-List-page:not(:last-child)': {
        borderBottom: `1px solid ${theme.palette.neutralLight}`,
      },
    },
  },
  multiLineRow: {
    selectors: {
      '& .ms-DetailsRow-cell': {
        maxHeight: 'auto',
      },
    },
  },
});
